import { Subject } from "rxjs/Subject";

export abstract class BaseService  {

    protected ngUnsubscribe: Subject<void> = new Subject<void>();

    ngOnDestroy(): void {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }
}



// WEBPACK FOOTER //
// ./src/core/controllers/base.service.ts